// React
import { PropsWithChildren } from "react"

// Icons
import { FaRegQuestionCircle } from "react-icons/fa"

export function HeaderMenu(params: PropsWithChildren<{
  onClickHelp?: () => void
  title: string
  className?: string
  action?: "create" | "edit" | "view"
}>) {

  let bgColor = ""
  switch (params.action) {
    case "create":
      bgColor = "bg-black"
      break;
    case "edit":
      bgColor = "bg-[#556134]"
      break;
    case "view":
      bgColor = "bg-red-800"
      break;
    default:
      bgColor = "bg-black"
      break;
  }

  return (
    <section className={`border flex items-center ${params.className ?? ""} `}>
      <section className={`p-3 ${bgColor} grow flex flex-wrap text-white text-xl font-bold items-center gap-3 ${params.children ? "justify-between" : "justify-center"}`}>
        <div className="uppercase">

          {params.action === "edit" && "edit | "}
          {params.action === "view" && "preview | "}
          
          {params.title}
        </div>

        {params.children && (
          <div >
            {params.children}
          </div>
        )}
      </section>

      <button
        className="p-3 bg-white"
        onClick={params.onClickHelp}
      >
        <FaRegQuestionCircle className="size-6" />
      </button>
    </section>
  )
}